// Trading Opponent - English
export default {
  loading: { text: "Loading..." },
  filters: {
    tag: "Tag",
    currency: "Currency",
    direction: "Direction",
    selectTag: "Select tag",
    selectCurrency: "Select currency",
    selectDirection: "Select direction",
    more: "More",
    amountRange: "Amount Range",
    minAmount: "Min amount",
    maxAmount: "Max amount",
  },
  table: {
    totalPrefix: "Total ",
    totalSuffix: " items",
    download: "Download",
    empty: "No Data",
    counterparty: "Counterparty",
    totalValue: "Amount",
    totalCount: "Tx Count",
    actions: "Actions",
  },
  directionOptions: {
    ALL: "Both",
    INFLOW: "Inflow",
    OUTFLOW: "Outflow",
  },
};
